<div class="overlay" (click)="onClick()" [ngClass]="{ show: isVisible }">
  <div class="message">
    <p [innerHTML]="message"></p>
  </div>
</div>
